import { render, staticRenderFns } from "./deactivate_parent_form.vue?vue&type=template&id=69be7bba&"
import script from "./deactivate_parent_form.vue?vue&type=script&lang=js&"
export * from "./deactivate_parent_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports